/* eslint-disable consistent-return */
/* eslint-disable max-len */
import axios from 'axios';
import { API_LICENCIAMIENTO } from '../config/config';
import {
  LOADING, SET_PURCHASE_PARAMETERS, SET_REJECT_TYPES, SET_SERVICE_TYPES,
  GET_FEATURE_TYPES, SET_VALUE_TAB, GET_PARAMETER_COMBO, GENERAL_SET_FILTERS_PAGE,
  GENERAL_SHOW_MESSAGE, SET_PARAMETER_APP,
  SET_STATES_AND_CITIES,
  GET_DOCUMENT_TYPE, GET_PARAMETERS_MARKET, SET_CUSTOMER_PARAMETERS,
  SET_CREATE_COUNTRIES_LIST, SET_CREATE_CUSTOMER_PARAMETERS,
} from '../types/general.type';
import {
  CLEAR_ERRORS,
} from '../types/purchaseLicense.type';
import { defaultHeaders, paramaterApplication } from '../helpers/generalUtils';
import { addLocalStorageEncript } from '../helpers/storageUtils';

export const getPurchaseOrderParametersAction = (countryCode = 'CO') => async (dispatch, getState) => {
  try {
    const docTypes = [];
    const itemsStatesList = [];
    const itemsAddress = [];
    const itemsAddressLetters = [];
    const itemsAddressBis = [];
    const itemsAddressCardinal = [];
    const parameterType = 'ParameterApps';
    const {
      general: { appName, tenant },
    } = getState();

    dispatch({ type: LOADING, payload: true });
    dispatch({ type: CLEAR_ERRORS, payload: {} });
    const config = defaultHeaders();
    if (tenant) {
      Object.assign(config.headers, {
        tenant,
      });
    }
    Object.assign(config.headers, {
      appName,
      parameterType,
      countryCode,
    });
    const applicationParameters = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetAppParameters`, config);
    const statesCities = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetListStatesAndCities`, config);
    const documentesTypes = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetAllDocumentTypes`, config);

    statesCities.data.result.records.forEach((item) => itemsStatesList.push(
      {
        value: item.id,
        text: item.stateName,
      },
    ));
    const statesAndCities = {
      statesList: statesCities.data.result.records,
      itemsStatesList,
    };

    documentesTypes.data.result.records.forEach((item) => docTypes.push(
      {
        value: item.id,
        text: item.documentTypeDesciption,
        documentTypeCode: item.documentTypeCode,
        documentTypeContrats: Array.isArray(item.documentTypeCountries) && item.documentTypeCountries.length > 0
          ? item.documentTypeCountries.map((country) => ({
            countryCode: country.country.countryCode,
            documentTypeCountriesDescription: country.documentTypeCountriesDescription,
            countryId: country.countryId,
          }))
          : [],
      },
    ));

    const application = applicationParameters.data.result.records;

    const assistantAddressTypes = {
      itemsAddress,
      itemsAddressLetters,
      itemsAddressBis,
      itemsAddressCardinal,
    };

    const data = {
      docTypes,
      assistantAddressTypes,
      statesAndCities,
      application,
    };

    addLocalStorageEncript(JSON.stringify(data), 'parametersApp');

    dispatch({
      type: SET_PURCHASE_PARAMETERS,
      payload: data,
    });

    dispatch({ type: LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
};

export const getRejectTypesAction = () => async (dispatch) => {
  try {
    const rejectTypes = [];
    const config = defaultHeaders();
    const rejectsTypesData = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetAllRejectTypes`, config);
    rejectsTypesData.data.result.records.forEach((item) => rejectTypes.push(
      {
        value: item.id,
        text: item.rejectTypeDescription,
      },
    ));

    dispatch({
      type: SET_REJECT_TYPES,
      payload: rejectTypes,
    });
  } catch (error) {
    console.error(error);
  }
};

export const getServiceTypesAction = () => async (dispatch) => {
  try {
    const serviceTypes = [];
    const config = defaultHeaders();
    const serviceTypesData = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetAllServiceTypes`, config);
    serviceTypesData.data.result.records.forEach((item) => serviceTypes.push(
      {
        value: item.id,
        label: item.serviceType1,
      },
    ));

    dispatch({
      type: SET_SERVICE_TYPES,
      payload: serviceTypes,
    });
  } catch (error) {
    console.error(error);
  }
};

export const setValueBackOfficeTab = (value) => (dispatch) => {
  dispatch({
    type: SET_VALUE_TAB,
    payload: value,
  });
};

export const getParameterByTypeAction = (parameterType) => async (dispatch) => {
  try {
    dispatch({ type: LOADING, payload: true });
    const parameterCombo = [];
    const config = defaultHeaders();
    const response = await axios.get(`${API_LICENCIAMIENTO}/license/api/Parameter/GetParameterByType?parameterCode=${parameterType}`,
      config);
    if (response.status === 200) {
      response.data.result.records.forEach((item) => parameterCombo.push(
        {
          value: item.parameterKey,
          label: item.parameterValue,
        },
      ));

      dispatch({ type: GET_PARAMETER_COMBO, payload: parameterCombo });
      dispatch({ type: LOADING, payload: false });
      return parameterCombo;
    }
  } catch (error) {
    console.error(`Error obteniendo la lista de clientes: ${error.message}`);
  }
};

export const getTokenExternalSourceAction = () => async () => {
  try {
    const config = defaultHeaders();
    const response = await axios.get(
      `${API_LICENCIAMIENTO}/license/api/Auth/GetTokenAdminIbuho`, config,
    );
    if (response.status === 200) {
      sessionStorage.setItem('tokenAdminIbuho', response.data.result.token);
    }
  } catch (error) {
    console.error(error);
  }
};

export const getFeatureTypesAction = () => async (dispatch) => {
  try {
    const featureTypes = [];
    const config = defaultHeaders();
    const featureTypesData = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetAllFeatureTypes`, config);
    featureTypesData.data.result.records.forEach((item) => featureTypes.push(
      {
        value: item.id,
        label: item.featureTypeName,
      },
    ));

    dispatch({
      type: GET_FEATURE_TYPES,
      payload: featureTypes,
    });
  } catch (error) {
    console.error(error);
  }
};

export const setFiltersPageAction = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: GENERAL_SET_FILTERS_PAGE,
      payload: filters,
    });
  } catch (error) {
    console.error(error);
  }
};

export const setMessageAlertAction = (data) => async (dispatch) => {
  try {
    dispatch({
      type: GENERAL_SHOW_MESSAGE,
      payload: data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const clearMessageAlertAction = () => async (dispatch) => {
  try {
    dispatch({ type: GENERAL_SHOW_MESSAGE, payload: undefined });
  } catch (error) {
    console.error(error);
  }
};

export const getParmeterConfigAction = (appName, parameterType, tenant = '') => async (dispatch) => {
  const config = defaultHeaders();
  Object.assign(config.headers, {
    appName, parameterType,
  });
  if (tenant) {
    Object.assign(config.headers, {
      tenant,
    });
  }
  const applicationParameters = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetAppParameters`, config);
  const result = applicationParameters?.data?.result?.records;
  const application = result?.parameters;
  const parameterConfig = paramaterApplication(application);
  if (parameterConfig.applyCash === undefined) {
    parameterConfig.applyCash = true;
  }
  const urlsFromBack = {
    urlPersonalDataTreatmentPolicy: result?.urlPersonalDataTreatmentPolicy,
    urlLandingPage: result?.urlLandingPage,
  };
  parameterConfig.urlsFromBack = urlsFromBack;
  parameterConfig.labels = {
    labelRegion: result?.labelRegion,
    labelCity: result?.labelCity,
  };
  dispatch({
    type: SET_PARAMETER_APP,
    payload: parameterConfig,
  });
};

export const getParametersAction = (appName, parameterType, tenant = '') => {
  const config = defaultHeaders();
  if (tenant) {
    Object.assign(config.headers, {
      tenant,
    });
  }
  Object.assign(config.headers, {
    appName, parameterType,
  });
  return new Promise((resolve, reject) => {
    try {
      axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetAppParameters`, config).then((res) => {
        resolve(res?.data?.result?.records?.parameters);
      }).catch((err) => {
        reject(err);
      });
    } catch (error) {
      console.log(error);
    }
  });
};

export const getStateAndCitiesAction = (countryCode = 'CO') => async (dispatch, getState) => {
  const config = defaultHeaders();
  const itemsStatesList = [];
  const {
    general: { appName, tenant },
  } = getState();
  if (tenant) {
    Object.assign(config.headers, {
      tenant,
    });
  }
  Object.assign(config.headers, {
    appName,
    countryCode,
  });
  try {
    const statesCities = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetListStatesAndCities`, config);
    if (statesCities.data?.result?.records?.length > 0) {
      statesCities.data.result.records.forEach((item) => itemsStatesList.push(
        {
          value: item.id,
          text: item.stateName,
        },
      ));
      const statesAndCities = {
        statesList: statesCities.data.result.records,
        itemsStatesList,
      };
      dispatch({
        type: SET_STATES_AND_CITIES,
        payload: statesAndCities,
      });
    }
  } catch (error) {
    console.error(error);
  }
};

export const getDocumentTypesAction = () => async (dispatch, getState) => {
  const config = defaultHeaders();
  const {
    general: { appName, tenant },
  } = getState();
  if (tenant) {
    Object.assign(config.headers, {
      tenant,
    });
  }
  Object.assign(config.headers, {
    appName,
  });
  try {
    const documentesTypes = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetAllDocumentTypes`, config);
    if (documentesTypes.data?.result?.records?.length > 0) {
      dispatch({
        type: GET_DOCUMENT_TYPE,
        payload: documentesTypes.data?.result?.records,
      });
    }
  } catch (error) {
    console.error(error);
  }
};

export const getParametersMarketAction = (appName, parameterType) => async (dispatch) => {
  try {
    const config = defaultHeaders();
    Object.assign(config.headers, {
      appName, parameterType,
    });
    const parametersMarket = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetAppParameters`, config);

    if (parametersMarket.status === 200) {
      dispatch({
        type: GET_PARAMETERS_MARKET,
        payload: parametersMarket?.data?.result?.records?.parameters,
      });
      return parametersMarket?.data?.result?.records?.parameters;
    }
  } catch (error) {
    console.error(error);
    dispatch({
      type: GET_PARAMETERS_MARKET,
      payload: [],
    });
  }
};

export const getParametersCustomerAction = (countryCode = 'CO') => async (dispatch, getState) => {
  try {
    const docTypes = [];
    const itemsStatesList = [];
    const itemsAddress = [];
    const itemsAddressLetters = [];
    const itemsAddressBis = [];
    const itemsAddressCardinal = [];
    const countriesList = [];
    const parameterType = 'ParameterApps';
    const {
      general: { appName, tenant },
    } = getState();

    dispatch({ type: LOADING, payload: true });
    dispatch({ type: CLEAR_ERRORS, payload: {} });
    const config = defaultHeaders();
    if (tenant) {
      Object.assign(config.headers, {
        tenant,
      });
    }
    Object.assign(config.headers, {
      appName,
      parameterType,
      countryCode,
    });
    const statesCities = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetListStatesAndCities`, config);
    const documentesTypes = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetAllDocumentTypes`, config);
    const countries = await axios.get(`${API_LICENCIAMIENTO}/license/api/customer/get-countries`, config);

    statesCities.data.result.records.forEach((item) => itemsStatesList.push(
      {
        value: item.id,
        text: item.stateName,
      },
    ));
    const statesAndCities = {
      statesList: statesCities.data.result.records,
      itemsStatesList,
    };

    documentesTypes.data.result.records.forEach((item) => docTypes.push(
      {
        value: item.id,
        text: item.documentTypeDesciption,
        documentTypeCode: item.documentTypeCode,
        documentTypeCountries: Array.isArray(item.documentTypeCountries) && item.documentTypeCountries.length > 0
          ? item.documentTypeCountries.map((country) => ({
            countryCode: country.country?.countryCode,
            documentTypeCountriesDescription: country.documentTypeCountriesDescription,
            countryId: country.countryId,
          }))
          : [],
      },
    ));

    countries.data.result.forEach((item) => countriesList.push(
      {
        value: item.id,
        text: item.name,
        countryCode: item.countryCode,
        addressLabel: item.addressLabel,
        stateLabel: item.stateLabel,
        cityLabel: item.cityLabel,
      },
    ));

    const assistantAddressTypes = {
      itemsAddress,
      itemsAddressLetters,
      itemsAddressBis,
      itemsAddressCardinal,
    };

    const data = {
      docTypes,
      assistantAddressTypes,
      statesAndCities,
      countriesList,
    };

    dispatch({
      type: SET_CUSTOMER_PARAMETERS,
      payload: data,
    });

    dispatch({ type: LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
};

export const getCreateCountriesAction = () => async (dispatch, getState) => {
  try {
    const countriesList = [];
    const {
      general: { appName, tenant },
    } = getState();

    const config = defaultHeaders();
    if (tenant) {
      Object.assign(config.headers, { tenant });
    }
    Object.assign(config.headers, { appName });

    const countries = await axios.get(`${API_LICENCIAMIENTO}/license/api/customer/get-countries`, config);

    countries.data.result.forEach((item) => countriesList.push({
      value: item.id,
      text: item.name,
      countryCode: item.countryCode,
      addressLabel: item.addressLabel,
      stateLabel: item.stateLabel,
      cityLabel: item.cityLabel,
    }));

    dispatch({
      type: SET_CREATE_COUNTRIES_LIST,
      payload: countriesList,
    });
  } catch (error) {
    console.error('Error fetching create countries:', error);
  }
};

export const getCreateCustomerParametersAction = (countryCode = 'CO') => async (dispatch, getState) => {
  try {
    const docTypes = [];
    const itemsStatesList = [];
    const parameterType = 'ParameterApps';
    const {
      general: { appName, tenant },
    } = getState();

    dispatch({ type: LOADING, payload: true });
    dispatch({ type: CLEAR_ERRORS, payload: {} });

    const config = defaultHeaders();
    if (tenant) {
      Object.assign(config.headers, { tenant });
    }
    Object.assign(config.headers, {
      appName,
      parameterType,
      countryCode,
    });

    const statesCities = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetListStatesAndCities`, config);
    const documentesTypes = await axios.get(`${API_LICENCIAMIENTO}/license/api/parameter/GetAllDocumentTypes`, config);

    statesCities.data.result.records.forEach((item) => itemsStatesList.push({
      value: item.id,
      text: item.stateName,
    }));

    const statesAndCities = {
      statesList: statesCities.data.result.records,
      itemsStatesList,
    };

    documentesTypes.data.result.records.forEach((item) => docTypes.push({
      value: item.id,
      text: item.documentTypeDesciption,
      documentTypeCode: item.documentTypeCode,
      documentTypeCountries: Array.isArray(item.documentTypeCountries) && item.documentTypeCountries.length > 0
        ? item.documentTypeCountries.map((country) => ({
          countryCode: country.country?.countryCode,
          documentTypeCountriesDescription: country.documentTypeCountriesDescription,
          countryId: country.countryId,
        }))
        : [],
    }));

    const data = {
      docTypes,
      statesAndCities,
    };

    dispatch({
      type: SET_CREATE_CUSTOMER_PARAMETERS,
      payload: data,
    });

    dispatch({ type: LOADING, payload: false });
  } catch (error) {
    console.error('Error fetching create customer parameters:', error);
    dispatch({ type: LOADING, payload: false });
  }
};
